var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashiconsAdminComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.5H24.5C26.425 3.5 28 5.075 28 7V19.25C28 21.175 26.425 22.75 24.5 22.75H21L12.25 31.5V22.75H8.75C6.825 22.75 5.25 21.175 5.25 19.25V7C5.25 5.075 6.825 3.5 8.75 3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsAdminComments);
export default __webpack_public_path__ + "static/media/dashicons-admin-comments.05a05489f340ef7fdfd6530f47762503.svg";
export { ForwardRef as ReactComponent };